import { Component } from "@angular/core";

@Component({
  selector: "app-household-sewage-treatment-notification",
  templateUrl: "./household-sewage-treatment-notification.component.html",
  standalone: false,
})
export class HouseholdSewageTreatmentNotificationComponent {}
